/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Links_0_LabelInputs */

const en_gc_search_guides_what_is_gridcraft_sections_2_links_0_label = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Links_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore charts and PivotTables`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_2_links_0_label = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Links_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索图表与数据透视表`)
};

/**
* | output |
* | --- |
* | "Explore charts and PivotTables" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Links_0_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_2_links_0_label = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Links_0_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Links_0_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_2_links_0_label(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_2_links_0_label(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_2_links_0_label as "gc.search_guides.what_is_gridcraft.sections.2.links.0.label" }